<template>
  <div class="my-2 mx-3">
    <!-- TODO substituir az-toolbar (ruim), por barra própria customizável, com o titulo e a busca juntos e responsivos -->
    <div class="cabecalho d-inline-flex">
      <div class="actions pt-2 pl-3">
        <az-title/>
      </div>
      <az-toolbar>
        <az-search slot="simpleSearch" @simple-search="buscaSimples" :filter="filtros"
                   @remove-filter="removerFiltro"
                   :simple-search-placeholder="placeholderPesquisa">
        </az-search>
      </az-toolbar>
    </div>
    <todas-licitacoes-tabela class="listagem-compras" :itens="itens"
                                  :paginas="paginas"
                                  :total-itens="totalItens"
                                  :paginacao="paginacao"
                                  @paginar="paginar"
                                  @acessar="acessar"
                                  @acessarLicitacaoSgc="acessarLicitacaoSgc"
                                  @baixarAta="baixarAta"/>
  </div>
</template>
<script>
import {actionTypes} from '@/core/constants'
import TodasLicitacoesTabela from './LicitacoesDisponiveisTabela'

export default {
    name: 'ConsultaDeLicitacoes',
    components: {TodasLicitacoesTabela},
    data(){
        return{
            itens:[],
            paginas: 0,
            totalItens: 10,
            paginacao: {
                page: 1,
                rowsPerPage: 10,
            },
            filtros: {
                conteudo: '',
                objeto: {
                    value: null,
                    default: null,
                    label: 'Pesquisa'
                }
            }
        }
    },
    computed: {
        placeholderPesquisa() {
            return 'Busque por: Nº Processo, Nº Edital, Objeto ou Órgão'
        }
    },
    methods:{
        async buscar() {
            const params = {
                filtros: this.filtros,
                paginacao: this.paginacao
            }
            params.paginacao.size = params.paginacao.rowsPerPage
            const resultado = await this.$store.dispatch(actionTypes.BUSCAR_LICITACOES_PUBLICAS, params)
            this.itens = resultado.items
            this.paginas = resultado.totalPages
            this.totalItens = resultado.totalElements
        },
        async buscaSimples(valor){
            if(valor) {
                this.filtros.objeto.value = valor
                this.filtros.conteudo = valor
            }
            await this.buscar()
        },
        async baixarAta(id){
            await this.$store.dispatch(actionTypes.BAIXAR_RELATORIO_DA_ATA_DA_LICITACAO, id)
        },
        acessar(licitacao){
            if (licitacao.linkAcessoExterno === null || licitacao.linkAcessoExterno === '') {
                let id = licitacao.id
                this.$router.push({name: 'licitacaoVisualizacaoDadosGerais', params: {id}})
            } else {
                window.open(licitacao.linkAcessoExterno, '_blank')
            }
        },
        acessarLicitacaoSgc(){
            const urlExecucao = 'licitacao/#/licitacoes'
            const url = `${window.location.protocol}//${window.location.hostname}/${urlExecucao}`
            window.open(url, '_blank')
        },
        paginar(paginacao) {
            this.paginacao = paginacao
            this.buscar()
        },
        removerFiltro(propriedade) {
            if (this.filtros && this.filtros.hasOwnProperty(propriedade)) {
                this.filtros[propriedade].value = this.filtros[propriedade].default
            }
            this.filtros.conteudo = ''
            this.buscar()
        },
        async atualizaDados(){
            this.desabilitarLoadingGlobal()
            await this.buscar()
            this.habilitarLoadingGlobal()
        }
    },
}
</script>
<style lang="stylus">
.az-toolbar
  background-color transparent
  border none

body
  background-color white
</style>
